export const MEDIA_CONTENT_IMAGE_FADE_DURATION_MS = 180;
export const MEDIA_CONTENT_PREVIEW_BLUR = 'blur(6px)';
export const MEDIA_CONTENT_PREVIEW_BLUR_REMOVE_DELAY_MS = 100;
export const MEDIA_CONTENT_PREVIEW_BLUR_REMOVE_DURATION_MS = 200;
